module.exports = __webpack_public_path__ + "img/应急支撑系统-bg.0e6b0aaa.jpg";